import { render, staticRenderFns } from "./GetFees.vue?vue&type=template&id=2ab3795a&"
import script from "./GetFees.vue?vue&type=script&lang=js&"
export * from "./GetFees.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports